import OrderCardsPage from './OrderCardsPage';

export default OrderCardsPage;